module.exports = __webpack_public_path__ + "img/engineeringCases44.5b913ced.jpg";